@if (isEdit()) {
  <h2 mat-dialog-title>Edit Registration</h2>
} @else {
  <h2 mat-dialog-title>Add Registration</h2>
}

<mat-dialog-content>
  <form id="registration-form" [formGroup]="registrationForm" (ngSubmit)="submit()">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Code</mat-label>
        <input matInput formControlName="code" />
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Registration Year</mat-label>
        <input
          matInput
          type="number"
          placeholder="YYYY"
          min="0"
          [max]="currentYear()"
          [formControl]="year"
        />
      </mat-form-field>
    </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-flat-button
    type="submit"
    form="registration-form"
    [disabled]="registrationForm.pristine || !registrationForm.valid"
  >
    Save
  </button>
  <button mat-button type="button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
